//  All Sections
import Hero from "Components/HomeComponent/Hero/Hero";
import GreekIsland from "Components/HomeComponent/GreekIsland/GreekIsland";
import OurPartners from "Components/HomeComponent/OurPartners";
import FellowSailor from "Components/HomeComponent/FellowSailor/FellowSailor";
import YatchOwner from "Components/HomeComponent/YatchOwner/YatchOwner";
import Discover from "Components/HomeComponent/Discover/Discover";
import GetInspire from "Components/HomeComponent/GetInspire/GetInspire";
import { Helmet } from "react-helmet";

// THIS IS A HOME PAGE 
const Home = () => {
  return (
    <>
     <Helmet>
        <title>Cyan | Booking beyond imagination</title>
      </Helmet>
      <Hero />
      <GreekIsland />
      <FellowSailor />
      <YatchOwner />
      <Discover />
      <OurPartners />
      <GetInspire />
    </>
  );
};


export default Home;
